import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export const Nav = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/shop", label: "Home" },
    { to: "/ar", label: "AR Preview" },
    { to: "/reservations", label: "My Bag" },
    { to: "/", label: "Cover" },
  ];

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 inset-x-0 z-40 bg-white/75 backdrop-blur-xl border-b border-[var(--kb-border)]"
    >
      <div className="px-5 sm:px-10 lg:px-14 py-4 flex items-center justify-between">
        <Link
          to="/shop"
          data-testid="nav-logo"
          className="font-serif text-2xl sm:text-3xl tracking-tight leading-none"
        >
          KISUBIKA
          <sup className="text-[9px] font-sans align-super ml-1 tracking-[0.2em] kb-blue">
            AR
          </sup>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={`kb-mono-label transition-colors ${
                pathname === l.to ? "kb-blue" : "text-[var(--kb-fg)] hover:kb-blue"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/ar"
            data-testid="nav-cta-secure"
            className="kb-btn-primary !py-3 !px-5"
          >
            Secure Your Bag
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden border-t border-[var(--kb-border)] bg-white"
        >
          <div className="flex flex-col px-5 py-6 gap-5">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.to.replace("/", "") || "home"}`}
                className="kb-mono-label"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/ar"
              onClick={() => setOpen(false)}
              className="kb-btn-primary"
              data-testid="nav-mobile-cta"
            >
              Secure Your Bag
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
